import { type NftDirection, NftFiltersKey, type NftFiltersKeyToQueryKeyMapping, type NftSort } from './types';

export const defaultNftDirection: NftDirection = 'Desc';
export const defaultNftSort: NftSort = 'purchase_date';

export const nftFiltersKeys = Object.values(NftFiltersKey);

export const nftFiltersKeyToQueryKeyMap: NftFiltersKeyToQueryKeyMapping = {
    [NftFiltersKey.Collections]: 'contract_addresses',
    [NftFiltersKey.Direction]: 'dir',
};

export const nftFiltersMultipleValueSupport = [
    NftFiltersKey.Collections,
    NftFiltersKey.Members,
    NftFiltersKey.Ownership,
];
